'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { createContext, use, useState } from 'react';
import type { AccommodationBookingContentName } from '../_lib/accommodation-config';
type AppAccommodationBookingBoxContextType = {
  showRoomRatesModal: boolean;
  navigateOnDateSubmit: boolean;
  activeContent: AccommodationBookingContentName | undefined;
  setActiveContent: (content: AccommodationBookingContentName | undefined) => void;
  setShowRoomRatesModal: (show: boolean) => void;
  setNavigateOnDateSubmit: (navigate: boolean) => void;
};
const AppAccommodationBookingBoxContext = createContext<AppAccommodationBookingBoxContextType | null>(null);
type AppAccommodationBookingBoxProviderProps = {
  children: ReactNode;
};
export function AppAccommodationBookingBoxProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [showRoomRatesModal, setShowRoomRatesModal] = useState(false);
  const [navigateOnDateSubmit, setNavigateOnDateSubmit] = useState(true);
  const [activeContent, setActiveContent] = useState();
  let t1;
  if ($[0] !== activeContent || $[1] !== navigateOnDateSubmit || $[2] !== showRoomRatesModal) {
    t1 = {
      activeContent,
      setActiveContent,
      showRoomRatesModal,
      setShowRoomRatesModal,
      navigateOnDateSubmit,
      setNavigateOnDateSubmit
    };
    $[0] = activeContent;
    $[1] = navigateOnDateSubmit;
    $[2] = showRoomRatesModal;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <AppAccommodationBookingBoxContext.Provider value={t1}>{children}</AppAccommodationBookingBoxContext.Provider>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function useAppAccommodationBookingBoxContext() {
  const context = use(AppAccommodationBookingBoxContext);
  if (!context) {
    throw new Error('useAppAccommodationBookingBoxContext must be used within AppAccommodationBookingBoxProvider');
  }
  return context;
}